<template lang="pug">
    div#dictionary
        Header
        div.row.cf__dictionary
            div.container
                div.infoBlock
                    h2.titleBlock Словарь
                    div.blockFilter
                        ul.filter__sort.filter__lang.mb10
                            li(v-for="(val, key) in filter" :key="key" @click="getWords(key)" :class="{'is-active': key === activeLang}") {{val.lang}}

                        ul.filter__sort.filter__abc
                            li(v-for="(val, key) in arrLetter" :key="key" @click="activeLetter = val" :class="{'is-active': val === activeLetter}") {{val}}

                    div.wrapper__sorting
                        ul.list(v-for="(sort, key) in words" :key="key" v-if="sort.symbol === activeLetter || filter[activeLang].letter[0] === activeLetter")
                            div.line
                                span.letter {{sort.symbol}}
                            li(v-for="(word, index) in sort.data" :key="index") {{word[activeLang] }}
                                span {{word.cir}}
                //infoBlock
            //container
        //cf__dictionary
</template>

<script>
    import Header from '@/components/Header.vue'
    import WordsService from '@/services/Words';

    export default {
        name: 'dictionary',
        data() {
            return {
                words: [],
                arrLetter: [],
                activeLetter: 'ru',
                activeLang: 'ru',
                filter: {
                    ru: {
                        lang: 'Русский',
                        letter: ['Все'],
                        data: []
                    },
                    en: {
                        lang: 'Английский',
                        letter: ['All'],
                        data: []
                    },
                    he: {
                        lang: 'Иврит',
                        letter: ['את כל'],
                        data: []
                    },
                }
            }
        },
        components: {
            Header,
            WordsService
        },
        mounted() {
            this.getWords(this.activeLang);
        },
        methods: {
            toCharAt(text) {
                return text.charAt(0).toUpperCase()
            },
            async getWords(lang) {
                let state = true;
                let letter = this.filter[lang].letter;
                let words = this.filter[lang].data;
                this.words = words;
                this.activeLang = lang;
                this.activeLetter = letter[0];
                this.arrLetter = letter;

                if (letter.length > 1) return state = true;

                await WordsService.getSort(lang).then(w => {
                    let item = w.data;
                    let word = [];
                    for (let i = 0; i < item.length; i++) {
                        let data = item[i];
                        let nextData = (item[i + 1] >= item.length) ? item[i] : item[i + 1];
                        if (nextData !== undefined) {
                            let currentItem = data[lang].charAt(0).toUpperCase();
                            let nextItem = nextData[lang].charAt(0).toUpperCase();
                            word.push({[lang]: data[lang], cir: data['cir']});
                            if (currentItem !== nextItem) {
                                if (state && currentItem !== ' ' && letter.indexOf(currentItem) === -1) {
                                    letter.push(currentItem);
                                }
                                if (state) {
                                    words.push({symbol: currentItem, data: word});
                                }
                                word = [];
                            }
                        }
                    }
                    state = false
                });
            }
        },
    }
</script>
